import React, { useContext } from "react";
import { WizardContext } from "../index";

export default function Footer({ prevStep, nextStep, nextBtnLabel }) {
  const {
    currentStep,
    setCurrentStep,
    resetState,
    homeLocation,
    setLocationError,
    teamSize,
    payButtonRef,
  } = useContext(WizardContext);
  return (
    <div className="modal-footer">
      {(prevStep == 0 || prevStep == 1 || prevStep == 2 || prevStep == 3) && (
        <div className="progressBar">
          <span>
            Step{" "}
            <b>
              {prevStep === 0
                ? "1/4"
                : prevStep === 1
                ? "2/4"
                : prevStep === 2
                ? "3/4"
                : "4/4"}
            </b>
          </span>
          <div
            className={`progress ${
              prevStep === 0
                ? "firstStep"
                : prevStep === 1
                ? "secondStep"
                : prevStep === 2
                ? "thirdStep"
                : "fourthStep"
            }`}
          >
            <span></span>
          </div>
        </div>
      )}
      <div className="actionBtns">
        {currentStep <= 4 && (
          <a
            onClick={() => {
              if (prevStep == 0) {
                handlePopupClose();
              } else {
                setCurrentStep(prevStep);
              }
            }}
            className="button"
          >
            Back
          </a>
        )}
        {nextStep != "last" && (
          <button
            onClick={(e) => {
              if (teamSize == 11) {
                e.preventDefault();
                jQuery(".tenPlusModalPopup").addClass("popupOpen");
                jQuery(".tenPlusModalPopup").fadeIn();
              } else {
                if (homeLocation == "" && nextStep == 2) {
                  e.preventDefault();
                  setLocationError(true);
                } else {
                  setLocationError(false);
                  setCurrentStep(nextStep);
                }
              }
            }}
            className="greenBtn"
          >
            {nextBtnLabel}
          </button>
        )}
        {nextStep == "last" && (
          <button
            onClick={() => {
              payButtonRef.current && payButtonRef.current.click();
            }}
            className="greenBtn proceedBtn"
          >
            Proceed to payment
          </button>
        )}
      </div>
    </div>
  );
}
